import {Container, Col, Row }from 'react-bootstrap';
import { ArrowLeftSquare, ArrowRightSquare } from 'react-bootstrap-icons';
import { useState, useEffect } from 'react';


interface ImageContainerProps {
    images: string[];
}

function ImageScroller({images}: ImageContainerProps){
    const [scrollindex, setScrollIndex] = useState(0);
    const scrollerimages = images;
    const altValue = "tempholder"


    const scrollRight = () => {
        if (scrollindex < (scrollerimages.length -1))
            setScrollIndex(scrollindex +1);


    }
    const scrollLeft = () => {
        if (scrollindex > 0)
            setScrollIndex(scrollindex -1);

        
    }

    useEffect(() => {
        document.getElementById("image-" + scrollindex)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }, [scrollindex]);

    return (
        /* Need to write code to capture half stars */
        <> 
            <Container>
                <Row>
                    <Col xs={{span: 1}} className="text-start color-font-primary d-flex align-items-center">
                        <div>
                            <ArrowLeftSquare size={30} onClick={() => scrollLeft()} />
                        </div>
                    </Col>
                    <Col className="style-side-scroller position-relative color-bg-primary" xs={{span: 10}}>
                        <div className="style-side-scroller-container">
                        { scrollerimages.map((item, index)  => 
                                <div id={"image-" + index} className="px-2">
                                    <img alt={altValue} className="square-image-block" src={item}/>
                                </div>
                        ) }
                        </div>
                    </Col>
                    <Col xs={{span: 1}}  className="text-end color-font-primary d-flex align-items-center">
                        <div>
                            <ArrowRightSquare size={30} onClick={() => scrollRight()} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ImageScroller;